import Alerts from 'lib/alerts';

import BatchPaymentConfigView from './BatchPaymentConfig.js';
import BatchPaymentConfig from 'newModels/batch-payment-config.js';
import FreeAccountSetup from 'commons/views/FreeAccountSetup';

import template from 'employer/templates/payroll/stepThree/Main.ejs';

import localStorageUtil from 'helpers/localStorageUtil';
import loader from 'helpers/loader';
import tooltip from 'helpers/tooltip';
import moment from 'moment';
import Decimal from 'decimal.js';

import {payrollStatus} from '../../../../new-models/payroll';

let showedRentasAlert = false;

module.exports = Backbone.View.extend({
    batchPaymentConfig:     null,
    batchPaymentConfigView: null,

    events: {
        'click .js-back':                    'back',
        'click .js-save':                    'save',
        'click .js-cancel':                  'cancel',
        'ifChecked input[name=paymentType]': 'toggleChequePickup'
    },

    initialize: function(options) {
        /* FIXME NEVER extend this with options like in the following line of
         * code, it can have unexpected consequences. The Backbone way is to
         * use a this.options object.
         * */
        _.extend(this, options);
        this.employees = _.sortBy(
            this.payslips.map(p => p.getEmployee()),
            employee => employee.get('fullName')
        );

        let promise = Promise.resolve(false);
        // NOTE there are some companies that erronously refer to
        // a deleted bank account id
        if (app.company.getBankAccount()) {
            promise = BatchPaymentConfig.isBankSupported(
                app.company.get('bankAccountId')
            );
        }
        return promise.then(supported => {
            this.batchPaymentConfig = new BatchPaymentConfig({
                payrollId: this.model.id,
                bankAccountId: app.company.get('bankAccountId')
            }, {bankAccount: app.company.getBankAccount()});

            this.batchPaymentConfigView = new BatchPaymentConfigView({
                model: this.batchPaymentConfig,
                supported
            });

            this.render();
        });
    },

    render: function() {
        // use employees to save same order in table
        this.employees.forEach(employee => {
            employee.payslip = this.payslips.find(
                payslip => {
                    return payslip.get('employeeId') === employee.id;
                });
        });

        const payrollPrice = this.model.get('billableAmount') / 100;
        const total = _.reduce(this.employees, function(memo, employee) {
            return memo +
                (employee.payslip.get('mtd') || 0) +
                (employee.payslip.get('cp38') || 0) +
                (employee.payslip.get('employeeEpf') || 0) +
                (employee.payslip.get('employerEpf') || 0) +
                (employee.payslip.get('employeeSocso') || 0) +
                (employee.payslip.get('employerSocso') || 0) +
                (employee.payslip.get('employeeEis') || 0) +
                (employee.payslip.get('employerEis') || 0) +
                (payrollPrice || 0);
        }, 0);
        this.$el.html(template({
            employees: this.employees,
            payrollPrice: payrollPrice || 'FREE',
            pcb: new Decimal(this.model.get('mtd') || 0)
                .plus(this.model.get('cp38') || 0)
                .toDP(2, Decimal.ROUND_HALF_UP)
                .toNumber(),
            epf: new Decimal(this.model.get('employeeEpf') || 0)
                .plus(this.model.get('employerEpf') || 0)
                .toDP(2, Decimal.ROUND_HALF_UP)
                .toNumber(),
            socso: new Decimal(this.model.get('employeeSocso') || 0)
                .plus(this.model.get('employerSocso') || 0)
                .toDP(2, Decimal.ROUND_HALF_UP)
                .toNumber(),
            eis: new Decimal(this.model.get('employeeEis') || 0)
                .plus(this.model.get('employerEis') || 0)
                .toDP(2, Decimal.ROUND_HALF_UP)
                .toNumber(),
            zakat: this.model.get('zakat') || 0,
            hrdf: this.model.get('hrdf') || 0,
            total: total,
            company: app.company,
            employerZakat: this.model.get('employerZakat'),

            showPaymentMethods: (
                this.model.getCompany().get('isManaged') !== false
            ),
            summaryPdf: this.model.has('summaryPdf') ?
                this.model.get('summaryPdf').url() : null,
            summaryXls: this.model.has('summaryXls') ?
                this.model.get('summaryXls').url() : null,
        }));

        this.$pickDate = this.$('.js-pickup-date');
        this.toggleChequePickup();

        this.$paymentType = this.$('.js-payment-methods input[type="radio"]');
        this.$paymentType.iCheck({radioClass: 'iradio_square-blue'});

        this.$('.js-crediting-date').datepicker({
            autoclose:      true,
            todayHighlight: true
        });

        this.$('.js-enable-batch-payments').iCheck({
            checkboxClass: 'icheckbox_square-blue'
        });

        this.$('.js-batch-payment-config').html('').append(
            this.batchPaymentConfigView.$el
        );

        tooltip.init(this);
        return this;
    },

    toggleFreeAccountSetup: function() {
        const button  = $('.js-free-account-setup');
        FreeAccountSetup
            .shouldShowFreeSetup()
            .then(show => {
                if (!show) {
                    button.hide();
                }
            }
            );
    },

    toggleChequePickup: function(ev) {
        var $el = ev ? this.$(ev.currentTarget) : false;

        if (!$el || $el.attr('value') === '2') {
            this.$pickDate.datepicker({
                startDate: moment().add(35, 'hours').toDate(),
                weekStart: 1,
                daysOfWeekDisabled: [0, 6],
                autoclose: true,
                todayHighlight: true
            });
        } else {
            this.$pickDate.datepicker('remove');
        }

        this.$pickDate.find('input').prop(
            'disabled', ($el && $el.attr('value') !== '2')
        );
    },

    save: function() {
        const submit = () => {
            var date = this.$pickDate.length ?
                this.$pickDate.datepicker('getDate') : null;
            var paymentType = this.$paymentType.filter(':checked').val();

            if ((paymentType === '2' && !date)) {
                Alerts.show('error', {
                    title: `Missing pickup date`,
                    text:  `Please provide a date you would like us to \
                        pickup your cheques`,
                    callback: () => this.$('.js-pickup-date i').click()
                });
                return;
            }

            this.batchPaymentConfigView.save().then(() => this.submitRequest({
                date: date,
                payroll: this.model,
                paymentType: paymentType
            }));
            this.toggleFreeAccountSetup();
        };

        if (this.shouldShowRentasAlert() && !showedRentasAlert) {
            this.showRentasAlert();
            showedRentasAlert = true;
        } else {
            submit();
        }
    },

    shouldShowRentasAlert: function() {
        const account = app.company.bankAccount;

        if (!account) {
            return false;
        }

        const eligibleForPayrollFile = payslip => {
            const employee = payslip.employee;
            const hasNetPay = payslip.get('netPay') > 0;
            const hasAccount  = employee.get('bankAccountId');
            return hasNetPay && hasAccount;
        };

        const allHaveEnough = (has, payslip) => {
            const net = parseFloat(payslip.get('netPay'));
            const lessThan = net < 10000;
            return has || lessThan;
        };

        const isRhbBank = account.get('bankBnmCode') === '18';

        const isRentas = account.get('transactionType') === '20';

        const hasAnyNetLesserThanAllowed = this.payslips
            .filter(eligibleForPayrollFile)
            .reduce(allHaveEnough, false);

        return isRhbBank && isRentas && hasAnyNetLesserThanAllowed;
    },

    showRentasAlert: function() {
        Alerts.show('warning', {
            title: `Important Note`,
            text:  `For RHB Bank: if the Payment Transaction type is Rentas, \
                The Employee Net Salary should be equal or more than RM10,000.`,
        });
    },

    submitRequest: function(data) {
        var stopLoader = loader.startFullScreen(this.$('.js-save'));

        return this.model.submit({
            chequePickupDate: data.date,
            paymentType: data.paymentType
        }).then(() => {
            localStorageUtil.removeItem('unsavedPayroll');

            Alerts.show('successConfirm', {
                title: 'Submitted!',
                text: 'Your payroll has been submitted.',
                cancelButtonText: 'Later',
                confirmButtonText: 'View Payroll Status',
                callback: function(isConfirm) {
                    if (isConfirm) {
                        app.mainRouter.navigate(
                            'payroll/history', {trigger: true}
                        );
                        return;
                    }

                    app.mainRouter.navigate('dashboard', {trigger: true});
                }
            });
        })
            .catch(err => {
                if (
                    err.statusCode === 400
                ) {
                    Alerts.show(
                        'warning',
                        {
                            title: 'Warning',
                            text: `Please note that your payroll has been \
                            modified. To view accurate calculations, \
                            please reload the page.`,
                            allowEscapeKey: false,
                            callback: window.location.reload
                                .bind(window.location)
                        }
                    );
                } else {
                    Alerts.show(
                        'criticalError',
                        err
                    );
                }
            }).finally(stopLoader);
    },

    back: function() {
        var stopLoader = loader.startFullPage();

        this.model.fetch()
            .then(() => {
                if (this.model.get('status') !== payrollStatus.CONFIRMED) {
                    const err = new Error('invalid status');
                    err.statusCode = 400;
                    throw err;
                }

                this.model.setStatus(payrollStatus.RAN).then(function() {
                    app.mainRouter.navigate('payroll/step/2', {trigger: true});
                });
            })
            .catch(err => {
                if (
                    err.statusCode === 400 ||
                (
                    err.response && err.response.error &&
                    err.response.error.statusCode === 400
                )
                ) {
                    Alerts.show(
                        'warning',
                        {
                            title: 'Warning',
                            text: `Please note that your payroll has been \
                            modified. To view accurate calculations, \
                            please reload the page.`,
                            allowEscapeKey: false,
                            callback: window.location.reload
                                .bind(window.location)
                        }
                    );
                } else {
                    Alerts.show(
                        'criticalError',
                        err
                    );
                }
            }).finally(stopLoader);
    },

    cancel: function() {
        Alerts.show('dangerConfirm', {
            text: 'You will not be able to recover this payroll',
            confirmButtonText: 'Yes, Restart',
            loader: true,
            callback: confirmed => {
                if (!confirmed) {
                    return;
                }
                this.model.destroy().then(() => {
                    localStorageUtil.removeItem('unsavedPayroll');
                    app.mainRouter.navigate('payroll/step/1', {trigger: true});
                    this.cancelSuccess();
                }, err => { Alerts.show('criticalError', err); });
            }
        });
    },

    cancelSuccess: function() {
        Alerts.show('success', {
            title: 'Payroll Reset!',
            text:  'Your Payroll has been reset.',
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepThree/Main.js